module.exports = __webpack_public_path__ + "static/media/delete-icon.aed30b4f.svg";